import { render, staticRenderFns } from "./intervalPictures.vue?vue&type=template&id=12be7a9a&scoped=true&"
import script from "./intervalPictures.vue?vue&type=script&lang=ts&"
export * from "./intervalPictures.vue?vue&type=script&lang=ts&"
import style0 from "./intervalPictures.vue?vue&type=style&index=0&id=12be7a9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be7a9a",
  null
  
)

export default component.exports